<main>
  <div class="maintenance-content">
    <img ngSrc="assets/logo.svg" width="61.57" height="32" alt="roche-logo" />
    <p class="ui-heading-2">Bookly is currently unavailable</p>
    <p class="ui-body-l">
      {{
        info()?.message ??
          'Bookly is temporarily unavailable. Please check back soon.'
      }}
    </p>
    @if (info()?.eta; as eta) {
      <p class="ui-body-m">Expected to be back: {{ eta | date: 'short' }}</p>
    }
    <button rds-primary-button (click)="retry()" [disabled]="isChecking()">
      Try again
    </button>
    @if (isChecking()) {
      <div>
        <rds-progress-bar></rds-progress-bar>
      </div>
    }
  </div>
</main>
